export default __webpack_public_path__ + "static/media/exterior2.3f809420.jpeg";